import type { AxiosExtendedRequestConfig } from '@web-chat-core/toolkit/src/api3';
import { DefaultMiddleware } from '@web-chat-core/toolkit/src/api3';
import { selectAuthToken } from 'state/selectors';

export class AuthHeaderMiddleware extends DefaultMiddleware {
    public constructor() {
        super(AuthHeaderMiddleware.name);
    }

    public async requestInterceptor(config: AxiosExtendedRequestConfig): Promise<AxiosExtendedRequestConfig> {
        const authToken = selectAuthToken();

        if (authToken && config.headers) {
            config.headers.authorization = `Bearer ${authToken}`;
        }

        return config;
    }
}
